"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuzzyTextFilterFn = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _matchSorter = require("match-sorter");
const FuzzyTextFilterFn = (rows, id, filterValue) => {
  return (0, _matchSorter.matchSorter)(rows, filterValue, {
    keys: [row => row.values[id]]
  });
};

// Let the table remove the filter if the string is empty
exports.FuzzyTextFilterFn = FuzzyTextFilterFn;
FuzzyTextFilterFn.autoRemove = val => !val;